import { Component, input, output, signal } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

import { AppLoaderComponent } from "@shared/components/app-loader";
import { WkTranslatePipe } from "@shared";
import { IAction } from "@shared/interfaces";

@Component({
    selector: "wk-modal",
    templateUrl: "./modal.component.html",
    styleUrl: "./modal.component.scss",
    host: {
        class: "wk-modal",
        "[attr.title]": "null",
    },
    imports: [JumpstartComponentsModule, AppLoaderComponent, WkTranslatePipe],
})
export class ModalComponent {
    public readonly title = input.required<string>();
    public readonly description = input<string>();
    public readonly counter = input<string>();
    public readonly confirmAction = input<IAction>();
    public readonly cancelActionTitle = input<string>("General.Cancel");
    public readonly confirmDisabled = input(false);

    public readonly closeModal = output<void>();

    protected readonly isUpdating = signal(false);

    protected async submit() {
        const action = this.confirmAction();
        if (!action || this.isUpdating() || this.confirmDisabled()) return;

        this.isUpdating.set(true);
        try {
            await action.event();
        } finally {
            this.isUpdating.set(false);
        }
    }

    protected close() {
        if (!this.isUpdating()) {
            this.closeModal.emit();
        }
    }

    protected handleUserRequest() {
        this.close();
    }
}
